export default {
  id: "",
  info: {},
};
